// Author Shi Wen Long
// Date 2024-12-20 15:43:31

import * as model from "@/model/sithMes/prd/SithMesPrdZpp2MaterialsDetailModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdZpp2MaterialsDetail(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .buildStore()
